import React from "react";
import styled, { css } from "styled-components";
import breakpoint from "../../../../utils/breakpoint";
import getBorderRadius from "../../../../utils/getBorderRadius";
import getColor from "../../../../utils/getColor";
import space from "../../../../utils/space";
import unit from "../../../../utils/unit";
import { borderRadiusSize, horizontalGutterSpace } from "../settings";
var Content = styled.div.withConfig({
  componentId: "sc-vcminf-0"
})(["margin-top:", ";", "{margin-top:", ";display:grid;grid-gap:", ";grid-template-columns:1fr auto auto;}"], space(3), breakpoint("medium"), space(3.5), space(horizontalGutterSpace));
var Main = styled.div.withConfig({
  componentId: "sc-vcminf-1"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["background-color:", ";border-radius:", ";padding:", " ", ";"], getColor(theme, "background"), getBorderRadius(theme, borderRadiusSize), space(1.5), space(2));
});
var Divider = styled.div.withConfig({
  componentId: "sc-vcminf-2"
})(function (_ref2) {
  var theme = _ref2.theme;
  return css(["width:", ";background-color:", ";"], unit(1), getColor(theme, "backgroundBlack", "default", 0.1));
});
var Aside = styled.div.withConfig({
  componentId: "sc-vcminf-3"
})(["align-self:center;", "{margin-top:", ";display:flex;flex-direction:column;}"], breakpoint("small", "medium"), space(2));
export default function AdditionalInfo(_ref3) {
  var main = _ref3.main,
    aside = _ref3.aside;
  return /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Main, null, main), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Aside, null, aside));
}